import Login from './components/Login.vue';
import Portal from './components/Portal.vue';

export const routes = [
    {
        path: '/',
        redirect: {
            name: "login"
        }
    },
    {
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: '/portal',
        name: "portal",
        component: Portal
    }
];



// WEBPACK FOOTER //
// ./src/routes.js